import React from "react";
import ImageBackground from "../components/ImageBackground";
import imgHeader from "../images/images-header/IMG_5427.jpg"; // Importar la imagen directamente
import "../styles/TerminosCondiciones.css";

import Par from "../components/Par";
import TitleSubtitle from "../components/TitleSubtitle";
import VerticalSeparator from "../components/VerticalSeparator";
import useFadeIn from "../hooks/useFadeIn";
import iconoLiderazgo from "../images/asistencia.png";
import iconoColaboracion from "../images/colaboracion.png";
import iconoPuntualidad from "../images/puntualidad.png";
import iconoResponsabilidad from "../images/seguridad-activada.png";

const TerminosCondiciones = () => {
  useFadeIn();

  return (
    <div>
      <ImageBackground url={imgHeader} />
      <VerticalSeparator altura="5" />
      <TitleSubtitle
        title="FADA Tours"
        subtitle="Términos y Condiciones"
        backgroundTitle="términos"
        position="centro"
      />
      <div className="">
        <Par position="centro">
          Estos Términos y Condiciones regulan el uso del canal digital de FADA
          Tours, así como la prestación de servicios turísticos. Al acceder y
          utilizar nuestros servicios, usted acepta estos Términos y
          Condiciones. Si no está de acuerdo con alguna parte, le solicitamos
          que no use nuestro canal digital.
        </Par>
        <VerticalSeparator altura="5" />
        <div className="bg-shadow">
          <TitleSubtitle
            title="Contacto"
            subtitle="Información de contacto"
            position="centro"
            backgroundTitle="contacto"
          />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Derechos de los Usuarios</h2>
              <ul className="subtitulos">
                FADA Tours, ubicado en Psj. Las Tunas, N° 263, La Banda de
                Shilcayo, Tarapoto, San Martín, Perú, está registrado bajo el
                RUC N° 10334313811. Puede contactarnos a través de:
                <li>
                  <a className="linkRedes" href="#">
                    • Correo Electrónico: fadatours.info@gmail.com
                  </a>
                </li>
                <li>
                  <a className="linkRedes" href="#">
                    • WhatsApp: +51941950860
                  </a>
                </li>
                <li>
                  <a className="linkRedes" href="#">
                    • Facebook: FADA Tours en Facebook
                  </a>
                </li>
                <li>
                  <a className="linkRedes" href="#">
                    • Instagram: FADA Tours en Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Objetivo" position="centro" />
          <div className="container-politics">
            <p className="parrafo fade-in">
              Estos Términos y Condiciones tienen como finalidad establecer las
              pautas de uso del canal digital de FADA Tours y regular la
              relación entre la agencia y los consumidores en la oferta,
              promoción y comercialización de servicios turísticos.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Servicios Ofrecidos" position="centro" />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours ofrece servicios de agencia de viajes, incluyendo la
              organización y promoción de tours, actividades recreativas y otros
              servicios relacionados con el turismo, conforme a la actividad
              económica 7911.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Registro y Normativas" position="centro" />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours está en proceso de inscripción en el Directorio
              Nacional de Prestadores de Servicios Turísticos Calificados del
              MINCETUR. Los usuarios serán informados de cualquier actualización
              en este sentido.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Protección de Datos Personales"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours se compromete a proteger la información personal de sus
              usuarios de acuerdo con la legislación vigente en materia de
              protección de datos. La información recabada será utilizada
              exclusivamente para fines relacionados con la prestación de
              nuestros servicios.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Canal Digital"
            subtitle="Términos de Uso del Canal Digital"
            position="centro"
            backgroundTitle="Térmidos de uso"
          />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Terminos de Uso</h2>
              <ul className="subtitulos">
                Al utilizar nuestro canal digital, usted acepta las siguientes
                condiciones:
                <li>
                  • La información proporcionada en nuestra plataforma es clara,
                  sencilla y transparente, y es fácilmente accesible desde la
                  página de inicio.
                </li>
                <li>
                  • Se implementan medidas de seguridad para proteger la
                  información y los pagos en línea, así como para resguardar los
                  datos personales de los usuarios.
                </li>
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Políticas de Cobro, Cancelación y Reembolso"
            position="centro"
          />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Cobro, Cancelación y Reembolso</h2>
              <ul className="subtitulos">
                <li>
                  • Política de Cobro: Los pagos se procesarán a través de
                  plataformas seguras. Los usuarios recibirán confirmación de
                  sus transacciones.
                </li>
                <li>
                  • Política de Cancelación: Las cancelaciones deberán
                  realizarse con al menos 48 horas de antelación para evitar
                  cargos adicionales.
                </li>
                <li>
                  • Política de Reembolso: Los reembolsos se procesarán conforme
                  a la normativa vigente y según las condiciones específicas de
                  cada servicio.
                </li>
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Política de Pérdida de Objetos"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours no se responsabiliza por la pérdida, robo o daño de
              objetos personales durante los tours. Es responsabilidad del
              usuario asegurarse de llevar sus pertenencias consigo y velar por
              su cuidado.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Cumplimiento de Normativas de ESNNA"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours se adhiere a las normativas que sancionan penalmente
              las conductas vinculadas a la explotación sexual de menores, así
              como otras disposiciones legales relacionadas. Disponemos de un
              afiche informativo en nuestro canal digital que detalla estas
              sanciones, cumpliendo con lo estipulado por el MINCETUR.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Aceptación de los Términos y Condiciones"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              El uso de nuestro canal digital implica la aceptación de estos
              Términos y Condiciones. Nos reservamos el derecho de modificar
              estos términos en cualquier momento, y cualquier cambio será
              notificado a los usuarios a través de nuestro sitio web.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Legislación Aplicable" position="centro" />
          <div className="container-politics">
            <p className="parrafo fade-in">
              Estos Términos y Condiciones se rigen por la legislación peruana y
              cualquier controversia que surja de la interpretación o ejecución
              de los mismos será resuelta en los tribunales competentes de Perú.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Definición de Usuario y Alcance"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              El término "Usuario" se refiere a cualquier persona que acceda,
              navegue o utilice los servicios proporcionados a través del canal
              digital de FADA Tours (sitio web, redes sociales, WhatsApp, entre
              otros). El Acuerdo de estos Términos y Condiciones se aplica a
              todos los servicios ofrecidos por FADA Tours relacionados con la
              promoción y comercialización de tours y actividades turísticas.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Política de Uso Aceptable" position="centro" />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Terminos de Uso</h2>
              <ul className="subtitulos">
                El Usuario se compromete a utilizar el canal digital de FADA
                Tours de manera responsable y legal. Las siguientes acciones
                están prohibidas:
                <li>
                  • Realizar actividades fraudulentas o ilegales, como el uso no
                  autorizado de tarjetas de crédito.
                </li>
                <li>
                  • Subir contenido que infrinja derechos de autor, marcas
                  registradas, o cualquier otro derecho de propiedad intelectual
                  de FADA Tours o de terceros.
                </li>
                <li>
                  • Utilizar el canal digital para difundir virus, malware o
                  cualquier otro software que pueda dañar el sistema de los
                  usuarios de FADA Tours.
                </li>
                <li>
                  • Realizar actividades que puedan alterar el buen
                  funcionamiento del canal digital o la seguridad de los datos
                  personales de otros usuarios.
                </li>
                FADA Tours se reserva el derecho de suspender o cancelar el
                acceso al canal digital a cualquier usuario que infrinja estas
                políticas.
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Política de Propiedad Intelectual"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              Todo el contenido del canal digital de FADA Tours, como textos,
              imágenes, gráficos, logotipos, marcas comerciales, y cualquier
              otro material protegido por derechos de propiedad intelectual, es
              propiedad exclusiva de FADA Tours o de sus respectivos
              licenciantes.
            </p>
            <p className="parrafo fade-in">
              Los Usuarios se comprometen a no reproducir, distribuir,
              modificar, mostrar públicamente ni realizar ninguna otra acción
              que implique el uso no autorizado del contenido sin el permiso
              explícito de FADA Tours.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Modificación de los Términos y Condiciones"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours se reserva el derecho de modificar, en cualquier
              momento, estos Términos y Condiciones sin previo aviso. Las
              modificaciones se publicarán en el canal digital y serán efectivas
              a partir de su publicación. Es responsabilidad del Usuario revisar
              periódicamente estos términos para estar al tanto de cualquier
              cambio. El uso continuo del canal digital de FADA Tours después de
              la modificación de los términos implica la aceptación de las
              nuevas condiciones.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Limitación de responsabilidad"
            position="centro"
          />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Terminos de Uso</h2>
              <ul className="subtitulos">
                FADA Tours se compromete a ofrecer servicios turísticos de
                calidad. Sin embargo, no será responsable por:
                <li>
                  • Daños directos o indirectos causados por el uso del canal
                  digital.
                </li>
                <li>
                  • Errores u omisiones en la información publicada en el sitio
                  web.
                </li>
                <li>
                  • Pérdida de datos o daños en equipos causados por el uso del
                  canal digital.
                </li>
                <li>
                  • Fallos en los servicios de terceros, como proveedores de
                  transporte, alojamiento o actividades recreativas, que afectan
                  la experiencia del usuario.
                </li>
                <li>
                  • FADA Tours no garantiza la disponibilidad continua de sus
                  servicios y no será responsable por interrupciones temporales
                  en el acceso al canal digital debido a mantenimiento o fallos
                  técnicos.
                </li>
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Cláusula de Expulsión del Tour"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours se reserva el derecho de expulsar a un usuario del tour
              si este realiza conductas inapropiadas, pone en peligro la
              seguridad de otros participantes o interfiere con el desarrollo
              normal de la actividad. En este caso, no se otorgará reembolso por
              los servicios no utilizados.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Cláusula de Resolución de Disputas"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              En caso de cualquier disputa o controversia relacionada con estos
              Términos y Condiciones, ambas partes (el Usuario y FADA Tours)
              intentarán resolver la disputa de manera amigable a través de la
              mediación. Si no se alcanza una solución mediante mediación, las
              disputas serán sometidas a arbitraje en el Centro de Arbitraje de
              la Cámara de Comercio de Lima, según las normas de arbitraje
              vigentes. Cualquier decisión tomada por el árbitro será vinculante
              para ambas partes.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Información sobre la ESNNA"
            subtitle="Protección de menores"
            position="centro"
          />
          <div className="container-politics">
            <p className="parrafo fade-in">
              Sobre la ESNNA, (Explotación Sexual de Niños, Niñas y
              Adolescentes) FADA Tours se adhiere firmemente a las disposiciones
              legales y normativas que sancionan la explotación sexual de
              menores, en cumplimiento con la legislación peruana y las
              políticas del MINCETUR. En nuestra plataforma, incluimos
              información sobre las sanciones penales relacionadas con la
              explotación sexual de niños, niñas y adolescentes (ESNNA). Todos
              los usuarios deben ser conscientes de que está estrictamente
              prohibido promover, facilitar o participar en actividades que
              vulneren los derechos de los menores de edad.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Política de Uso Aceptable" position="centro" />
          <div className="container-politics">
            <div className="parrafo fade-in">
              <h2 className="title fade-in">Terminos de Uso</h2>
              <ul className="subtitulos">
                FADA Tours utiliza cookies para mejorar la experiencia del
                Usuario en el canal digital. Las cookies son pequeños archivos
                que se almacenan en el dispositivo del usuario y se utilizan
                para:
                <li>• Mejorar la navegación en el sitio web.</li>
                <li>• Personalizar el contenido mostrado al usuario.</li>
                <li>
                  • Realizar análisis estadísticos sobre el uso de la
                  plataforma.
                </li>
                El Usuario puede optar por deshabilitar las cookies en su
                navegador, aunque esto podría afectar el funcionamiento de
                algunos servicios del canal digital.
              </ul>
            </div>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle title="Garantías y exenciones" position="centro" />
          <div className="container-politics">
            <p className="parrafo fade-in">
              FADA Tours ofrece servicios turísticos conforme a las mejores
              prácticas de la industria, pero no garantiza resultados
              específicos, como la satisfacción total de los Usuarios en todos
              los aspectos de los servicios contratados. Además, FADA Tours no
              es responsable por daños causados por condiciones externas, como
              mal tiempo, retrasos por parte de proveedores de transporte, o
              problemas ajenos a nuestra operación directa. Los Usuarios eximen
              a FADA Tours de responsabilidad en caso de pérdidas, daños, o
              inconvenientes derivados de su participación en las actividades
              turísticas ofrecidas.
            </p>
            <p className="parrafo fade-in">
              Contacto: Para cualquier consulta relacionada con estos Términos y
              Condiciones, contáctenos a través de los medios mencionados
              anteriormente.
            </p>
          </div>
          <VerticalSeparator altura="5" />
        </div>
        <div className="bg-shadow">
          <TitleSubtitle
            title="Nuestro Valores"
            backgroundTitle="valores"
            position="izquierda"
          />
          <VerticalSeparator altura="2" />
          <div className="valores-section">
            <div className="valores-grid">
              <div className="valor-item">
                <img src={iconoResponsabilidad} alt="Responsabilidad" />
                <h3>Compromiso con el Cliente</h3>
                <p>
                  En FADA Tours, nuestros clientes son nuestra prioridad. Nos
                  esforzamos por brindar una atención personalizada y garantizar
                  que cada experiencia de viaje supere sus expectativas,
                  cuidando cada detalle.
                </p>
              </div>
              <div className="valor-item">
                <img src={iconoPuntualidad} alt="Puntualidad" />
                <h3>Transparencia y Ética</h3>
                <p>
                  Actuamos con honestidad y claridad en todas nuestras
                  operaciones, desde la planificación del viaje hasta la
                  finalización del servicio. Mantenemos relaciones basadas en la
                  confianza y la integridad con nuestros clientes, empleados y
                  socios.
                </p>
              </div>
              <div className="valor-item">
                <img src={iconoLiderazgo} alt="Liderazgo" />
                <h3>Calidad en el Servicio</h3>
                <p>
                  ofrecemos servicios turísticos de alta calidad, seleccionando
                  cuidadosamente a nuestros proveedores y destinos para asegurar
                  una experiencia memorable y placentera. Nos esforzamos
                  constantemente por mejorar y superar los estándares del
                  sector.
                </p>
              </div>
              <div className="valor-item">
                <img src={iconoColaboracion} alt="Colaboración" />
                <h3>Sostenibilidad</h3>
                <p>
                  Nos comprometemos con el turismo responsable y sostenible,
                  respetando el medio ambiente y las culturas locales en cada
                  destino. Promovemos prácticas que minimicen nuestro impacto
                  ambiental y contribuyan al desarrollo positivo de las
                  comunidades que visitamos.
                </p>
              </div>
            </div>
          </div>
        </div>
        <VerticalSeparator altura="5" />
      </div>
    </div>
  );
};

export default TerminosCondiciones;
